module.exports = __webpack_public_path__ + "media/images/list-8a64818a69f6c4c2bc2ba259af97c266.svg";